// prettier-ignore
import { Component, OnInit, EventEmitter, ViewChild, Input } from "@angular/core";
import { Aguas, CargosDetallesInput, EstadoCuentaInformacionInput, RegistroBitacoraInput } from "../../../app/entidades/entidades";
import { MuestraMensaje } from "../../../app/shared/utilerias/notificaciones/notificaciones.component";
import { EstadoCuentaInformacionComponent } from '../../componentes/estado-cuenta-informacion/estado-cuenta-informacion.component';
import { RegistroBitacoraService } from '../../servicios/registro-bitacora.service';

declare var $: any;

@Component({
    selector: "app-estado-cuenta",
    templateUrl: "./estado-cuenta.component.html",
    styleUrls: ["./estado-cuenta.component.css"],
})

export class EstadoCuentaComponent implements OnInit {
    //aguasProceso: Aguas;
    idAguasProceso: number;
    public cargosDetallesInput$ = new EventEmitter<CargosDetallesInput>();
    public estadoCuentaInformacionInput$ = new EventEmitter<EstadoCuentaInformacionInput>();
    muestraMensaje = new MuestraMensaje();
    public cargosDetallesInputLimpio: CargosDetallesInput;
    public estadoCuentaInformacionLimpio: EstadoCuentaInformacionInput;
    public registroBitacora = new RegistroBitacoraInput();
    @Input("flagEdicion") flagEdicion: boolean = false;
    @Input("flagPrescripcion") flagPrescripcion: boolean = false;

    @ViewChild(EstadoCuentaInformacionComponent, { static: false }) childEstadoCuentaInformacion;
    constructor(private registroBitacoraService: RegistroBitacoraService) { }

    ngOnInit() {
        //ruta del componenete
        
     }
    //async childAguaBuscaCuentas(aguas: Aguas) {
    async childAguaBuscaCuentas(idAgua: number) {
        try {

            this.idAguasProceso = idAgua;
            //let medidoresBusquedas = new Medidores();

            if (!this.idAguasProceso) {
                this.cargosDetallesInput$.emit(null);
                this.estadoCuentaInformacionInput$.emit(null);
                return;
            }

            await this.cargaDetallesAdeudo(idAgua);
            /*await this.cargaInformacionEdoCuenta(aguas);*/

            /*this.registroBitacora.idAgua = idAgua;
            this.registroBitacora.accion = "CONSULTA ESTADO DE CUENTA";
            const datRetorno = await this.registroBitacoraService.add(this.registroBitacora).toPromise();*/

        } catch (e) {
            this.muestraMensaje.error(e.message, "top", "center");
        } finally {
            console.log("Paso por childAguaBuscaCuentas");
        }
    }
    //async cargaDetallesAdeudo(aguas: Aguas) {
    async cargaDetallesAdeudo(idAguas: number) {

        try {
            //Carga detalle adeudos
            let cargosDetallesInput = new CargosDetallesInput();
            cargosDetallesInput.idAgua = (idAguas);
            cargosDetallesInput.idEstatus = 1;
            await this.cargosDetallesInput$.emit(cargosDetallesInput);

        } catch (e) {
            this.muestraMensaje.error(e.message, "top", "center");
        } finally {
            console.log('Paso por cargaDetallesAdeudo');
        }
    }

    //async cargaInformacionEdoCuenta(aguas: Aguas) {
    async cargaInformacionEdoCuenta(idAguas: number) {
        try {

            //Carga Informacion Estado de Cuenta
            let estadoCuentaInformacionInput = new EstadoCuentaInformacionInput();
            estadoCuentaInformacionInput.idAgua = idAguas;
            //estadoCuentaInformacionInput.cuentaAgua = aguas.cuentaAgua;
            await this.estadoCuentaInformacionInput$.emit(estadoCuentaInformacionInput);
        } catch (e) {
            this.muestraMensaje.error(e.message, "top", "center");
        } finally {
            console.log('Paso por cargaInformacionEdoCuenta');
        }
    }

    totalAdeudoOutput(totalAdeudo: number) {
        //console.log('-------->',this.childEstadoCuentaInformacion.estadoCuentaTable,', TOTAL _-_-_-_-->', totalAdeudo);
        if (this.childEstadoCuentaInformacion.estadoCuentaTable) {
            this.childEstadoCuentaInformacion.estadoCuentaTable[0].total = totalAdeudo;
        }
        this.cargaInformacionEdoCuenta(this.idAguasProceso);
    }
}
